import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOnboardingStatus } from '../../services/OnboardingService';
import { clarityEvent } from '../../utils/clarity';
import { trackEvent } from '../../utils/googleAnalytics';

const DISMISS_KEY = 'welcomeDismissed';

const HIGHLIGHTS = [
    'Connect your Binance API keys in Settings.',
    'Set up Telegram or email alerting.',
    'Create your first automation and run a backtest.',
];

/**
 * First-run welcome. Shows once per browser session to users who have never
 * finished onboarding, and points them at the Getting Started checklist.
 */
function WelcomeModal() {
    const navigate = useNavigate();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (
            typeof sessionStorage !== 'undefined' &&
            sessionStorage.getItem(DISMISS_KEY) === 'true'
        )
            return;

        getOnboardingStatus()
            .then(status => {
                if (status && !status.onboardedAt) {
                    setShow(true);
                    trackEvent('welcome_modal_view');
                    clarityEvent('welcome_modal_view');
                }
            })
            .catch(err =>
                console.error(err.response ? err.response.data : err.message),
            );
    }, []);

    function dismiss() {
        if (typeof sessionStorage !== 'undefined')
            sessionStorage.setItem(DISMISS_KEY, 'true');
        setShow(false);
    }

    function goToChecklist() {
        dismiss();
        navigate('/onboarding');
    }

    if (!show) return <></>;

    return (
        <>
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <h3 className="modal-title h4">
                                Welcome to ArgosTraderBot
                            </h3>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={dismiss}
                            ></button>
                        </div>
                        <div className="modal-body pt-2">
                            <p className="text-gray-600">
                                Let's get you set up. These are the essentials
                                to start trading safely:
                            </p>
                            <ul className="mb-3 ps-3">
                                {HIGHLIGHTS.map(item => (
                                    <li key={item} className="mb-1">
                                        {item}
                                    </li>
                                ))}
                            </ul>
                            <p className="text-gray-600 mb-0">
                                We track each step for you on the Getting
                                Started page, so you always know what is left.
                            </p>
                        </div>
                        <div className="modal-footer border-0 pt-0">
                            <button
                                className="btn btn-outline-gray-600"
                                onClick={dismiss}
                            >
                                Maybe later
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={goToChecklist}
                            >
                                Open Getting Started
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default WelcomeModal;
